<template>
  <div class="ifizxlaw">
    <div class="title2">在线律师</div>
    <div class="num2">5822人</div>
    <div class="ddesc2">在线等待为您解答</div>
    <div class="ys between text_center">
      <div class="ysitem">
        <div class="ic2 center">
          <img src="~assets/question/kszxicon1.png" alt="" />
        </div>
        <div>详细描述问题</div>
      </div>
      <div class="ysitem">
        <div class="ic2 center">
          <img src="~assets/question/kszxicon2.png" alt="" />
        </div>
        <div>律师细致解答</div>
      </div>
      <div class="ysitem">
        <div class="ic2 center">
          <img src="~assets/question/kszxicon3.png" alt="" />
        </div>
        <div>完美解决问题</div>
      </div>
    </div>
    <div class="fast2 center">快速咨询</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.ifizxlaw {
  width: 100%;
  height: 100%;
  padding: 55px 24px 0;
  text-align: center;
  background: url("~assets/question/online_law.png") no-repeat;
  .title2 {
    font-size: 24px;
    color: #333333;
    line-height: 30px;
  }
  .num2 {
    font-size: 36px;
    margin-top: 28px;
    color: #333333;
    line-height: 36px;
  }
  .ddesc2 {
    font-size: 16px;
    color: #666666;
    margin-top: 13px;
    line-height: 16px;
  }
  .ys {
    font-size: 12px;
    color: #999999;
    margin-top: 35px;
    .ysitem {
        width: 75px;
      .ic2 {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        margin: 0 auto 12px;
        background-color: #efeffb;
        img {
          width: 18px;
          height: 18px;
        }
      }
    }
  }
  .fast2 {
    cursor: pointer;
    font-size: 20px;
    color: #ffffff;
    width: 200px;
    height: 48px;
    background: #f25717;
    border-radius: 24px;
    margin: 35px auto 0;
  }
}
</style>